import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { ApisService } from "@core/services/apis.service";
import { LanguageService } from "@core/services/language.service";
import { LoadingService } from "@core/services/loading.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  ColumnMode,
  DatatableComponent,
  SelectionType,
} from "@swimlane/ngx-datatable";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-open-screens",
  templateUrl: "./open-screens.component.html",
  styleUrls: ["./open-screens.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class OpenScreensComponent implements OnInit {
  public arrCoupons: any[] = [];
  lang: string;

  constructor(
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,
    private modal: NgbModal , 
    private loading : LoadingService , 
    private language : LanguageService,    private toastr : ToastrService
  ) {}

  public currentPage = 1;
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;

  public levels: any[] = [];
  public tempData = [];
  public openScreens: any;
  public openScreenDetails: any;

  @ViewChild(DatatableComponent) table: DatatableComponent;

  // ngOnInit(): void {
  //   this.getLevels();

  // }
  ngOnInit(): void {
    this.language.currentLang.subscribe(data => this.lang = data)
    this.getOpenScreens();
  }

  getOpenScreens() {
    this.loading.show();
    this.apisService.getOpenScreens(this.currentPage).subscribe({
      next: (res) => {
        this.openScreens = res.data;
        this.totalItems = this.openScreens.length;
        this.loading.hide();
      },
      error: (err) => {
        console.log("error in fetching", err);
        this.loading.hide();
      },
    });
  }

  /*----------  Handling image Error  ----------*/
  handleImageError(event) {
    event.target.src = "assets/images/icons/logo.jpg";
  }

  open(content: any, row: any) {
    this.openScreenDetails = row;
    console.log(this.openScreenDetails);
    this.modal.open(content, { centered: true, size: "lg" });
  }

  close() {
    this.modal.dismissAll();
  }

  /*=====  End of Modal functions  ======*/

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.arrCoupons = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }

  /*----------  Pagination Functions   ----------*/
  next() {
    this.currentPage++;
    this.getOpenScreens();
  }

  prev() {
    this.currentPage--;
    this.getOpenScreens();
  }

   /*----------  delete main category  ----------*/
 deleteOpenScreen(id: number) {
   this.apisService.deleteOpenScreens(id).subscribe({
     next: (res) => {
       this.getOpenScreens();
       this.toastr.success(" deleted successfully", "Success");
     },
     error: (err) => {
       console.log('error in fetching', err)
       this.toastr.error("Something went wrong", "Error")
     }
   })
 }

}
